import VueRouter from 'vue-router'
import routes from './routes'
import db from "@/libs/utils/db";

let isPageLoad = false;
//判断访问路径路由path是否存在
function isRouterPathExist(path){
    console.log(path);
    let isExist = false
    if(path){
        if(routes.some(item=>path == item.path)){
            return true
        }
        for(var t=0;t<routes.length;t++){
            if(routes[t].children && routes[t].children.length>0){
                if(routes[t].children.some(item=> path == item.path)){
                    isExist = true
                    break
                }
            }
        }
    }else{
        return false
    }
    return isExist
}

const router = new VueRouter({
    mode: 'hash',
    routes:routes
})

router.beforeEach((to, from, next) => {
   // var domainAr = utils.urlParam();
    if(!isPageLoad) {
        isPageLoad = true;
        let admin = db.getStorageSync("adminUser");
        // 有本地登录信息就恢复到 store，保证请求头能带上 token（不依赖 admin.merchants）
        if(admin != null && Object.keys(admin).length > 0) {
            const store = require('@/store/index').default;
            store.dispatch("cashier/user/setUser", admin);
        }
    }
    //判断是否登录 | ---
    let notAr = ['/login','/reg','/findPass'];
    let admin = db.getStorageSync("adminUser");
    if(notAr.indexOf(to.path) < 0 && (!admin || Object.keys(admin).length == 0)){
        const store = require('@/store/index').default;
        store.dispatch("cashier/page/keepAliveClean",{});
        next({ path:'/login'});
        return;
    }
    //进行前期适配
    if(isRouterPathExist(to.path)){
      //  store.dispatch("cashier/page/keepAlivePush",to.name);
        next()
    } else {
        next({ path:'/404'})
    }
});

router.afterEach((to, from) => {
    const store = require('@/store/index').default;
    store.dispatch("cashier/page/setKeepath",to.name);
    store.dispatch("cashier/page/setKeepName",to.meta.title);
    store.dispatch("cashier/page/setKeep",to);
    if(to.meta.keepAlive != null && to.meta.keepAlive) {
        store.dispatch("cashier/page/keepAlivePush",to.name);
    }
});


export default router
